function initialState() {
  return { campaigns: null };
}

export function campaigns(state = initialState(), action) {
  switch (action.type) {
    case 'SET_CAMPAIGNS':
      return { ...state, campaigns: action.campaigns };
    default:
      return state;
  }
}
